import Checkboxer, { Radio } from "./Checkboxer";
Checkboxer.Radio = Radio;
export default Checkboxer;